import { providers } from '~/types/oembed';

export function useVideoEmbed(resource: MaybeRefOrGetter<string>) {
  const provider = providers.find(p => p.supports(toValue(resource)));

  const oembed = async () => {
    if (!provider) {
      return null;
    }

    return provider.proxy
      ? await $fetch(`/api/oembed/${provider.name}`, { params: { url: toValue(resource) } })
      : await provider.fetch(toValue(resource));
  };

  return {
    supported: !!provider,
    provider: provider,
    url: provider?.getEmbedUrl(toValue(resource)),
    id: provider?.getId(toValue(resource)),
    oembed,
  };
}
